import React, {Component} from 'react';
import * as R from 'ramda';
import {connect} from 'react-redux';

import Rate from 'js/components/rate';
import Button from 'js/components/button';
import Caption from 'js/components/caption';
import RejectedBubbles from 'js/components/rejected_bubbles';
import ApprovedBubbles from 'js/components/approved_bubbles';
import ConfigurableStar from 'js/components/configurable_star';
import SocialUsernameWithAvatar from 'js/components/social_username_with_avatar';
import ContentApprovalTimer from 'js/components/content_approval_timer';

import {EditRequestsForm} from '../edit_requests_form';
import {dateFormatter} from 'js/common/date_helper';

import './index.scss';
import {EditRequestsFormInternal} from '../edit_requests_form_internal';
import ContentType from '../content_type';
import ContentSubmittedDate from '../content_submitted_date';

import {FormButton, Tag, TextInput} from '@social-native/snclient-ui';
import '@social-native/snclient-ui/dist/style.css';

import {
    createCreatorTag, deleteCreatorTag, updateCreatorTag, linkTagToContent, unlinkTagFromContent,
} from '../../brand/brand_api_client';

const statuses = {
    APPROVED: 'approved',
    REJECTED: 'rejected'
};

const userRole = window.sn.navigationMenu;

class ContentRow extends Component {
    static defaultProps = {
        onApprove: R.identity,
        onReject: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            isRating: false,
            status: props.status,
            toggleForm: false,
            toggleReadMore: false,
            rating: 0,
            isLabelEditionVisible: false,
            tags: props.tags || [],
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({status: nextProps.status});
    }

    handleApprove = () => {
        this.props.onApprove({rating: this.state.rating});

        this.setState({
            isRating: false,
            status: statuses.APPROVED
        });
    };

    onReject = () => {
        this.props.onReject();
    };

    onDoNotPost = () => {
        const {onDoNotDistribute} = this.props;
        onDoNotDistribute();
        this.setState({
            isRating: false,
            status: statuses.REJECTED
        });
    };

    handleRating = rating => {
        this.setState({rating});
    };

    handleRequestEditClick = () => {
        this.setState({toggleForm: !this.state.toggleForm});
    };

    renderComment = ({email, text, timestamp}) => (
        <div
            key={timestamp}
            className="content-row__activity-item"
            data-email={email}
            data-timestamp={dateFormatter(timestamp, 'MM/DD/YY H:mmz')}
        >
            {text}
        </div>
    );

    renderComments = () => {
        const {comments} = this.props;

        if (R.isNil(comments) || R.isEmpty(comments)) {
            return (
                <div className="content-row__no-activity">
                    <div>No recent activity</div>
                </div>
            );
        }

        return R.map(this.renderComment, comments);
    };


    renderLabels() {
            const { isLabelEditionVisible, tags} = this.state;

            const handleCreateOrUpdateTag = async (tagId) => {
                const { newLabelName } = this.state;
                const { contentMetadataId } = this.props;
            
                if (!newLabelName) {
                    console.error('Label name cannot be empty');
                    return;
                }
            
                try {
                    let response;
                    const { newLabelName, tags } = this.state;

                    if (!newLabelName) {
                        console.error('Label name cannot be empty');
                        return;
                    }

                    const updateState = (updatedTags) => {
                        this.setState({
                            tags: updatedTags,
                            isLabelEditionVisible: false,
                            newLabelName: '',
                        });
                    };

                    try {
                        const response = tagId
                            ? await updateCreatorTag(newLabelName, tagId)
                            : await createCreatorTag(newLabelName);

                        const updatedTags = tagId
                            ? tags.map((tag) =>
                                tag.tag_id === tagId ? { ...tag, name: newLabelName } : tag
                              )
                            : [...tags, { tag_id: response.id, name: newLabelName, content_metadata_id: contentMetadataId }];

                        if (!tagId && contentMetadataId) {
                            await linkTagToContent(response.id, contentMetadataId);
                        }

                        updateState(updatedTags);
                    } catch (error) {
                        console.error('Error saving or updating tag:', error);
                    }
                } catch (error) {
                    console.error('Error saving or updating tag:', error);
                }
            };

            const handleDeleteTag = async (tagId) => {
                const { contentMetadataId } = this.props;

                try {
                    const response = await deleteCreatorTag(tagId);

                    if (contentMetadataId) {
                        await unlinkTagFromContent(tagId, contentMetadataId);
                    }

                    this.setState((prevState) => ({
                        tags: prevState.tags.filter(tag => tag.tag_id !== tagId)
                    }));
                } catch (error) {
                    console.error('Error deleting tag:', error);
                }
            };

            return (
                <div className="content-row__creator-labels">

                    {(tags.length > 0 || userRole.isAdmin) && (
                        <p className="title">Creator Labels</p>
                    )}

                    <div className="creator-labels-tags">       
                        {tags.map(tag => (
                            <Tag
                                key={tag.tag_id}
                                label={tag.name}
                                color="gray"
                                size="small"
                                onDelete={() => handleDeleteTag(tag.tag_id)}
                                onEdit={() => this.setState({ isLabelEditionVisible: true, tagId: tag.tag_id })}
                                enableMenu
                                menuLabel={{
                                    delete: 'Delete',
                                    edit: 'Edit'
                                }}
                            />
                        ))}

                        {userRole.isAdmin && (
                        <FormButton
                            icon="plus"
                            color="gray"
                            alt
                            className="add-label-button"
                            size="small"
                            onClick={() => this.setState({ isLabelEditionVisible: true })}
                            role="button"
                        >
                            Add Label
                        </FormButton>
                        )}

                    </div>

                    {isLabelEditionVisible && userRole.isAdmin && (
                    <div className="creator-label-edition">
                        <TextInput 
                            placeholder="New label"
                            value={this.state.newLabelName || tags.find(tag => tag.tag_id === this.state.tagId)?.name || ''}
                            onChange={(e) => this.setState({ newLabelName: e.target.value })}
                        />
                        <FormButton
                            icon="check"
                            color="green"
                            alt
                            size="small"
                            onClick={() => handleCreateOrUpdateTag(this.state.tagId && this.state.tags.find(tag => tag.tag_id === this.state.tagId)?.tag_id)}
                            role="button"
                        >
                            Save
                        </FormButton>
                        <FormButton
                            icon="xmark"
                            color="gray"
                            alt
                            size="small"
                            onClick={() => this.setState({ isLabelEditionVisible: false, newLabelName: '', tagId: null })}
                            role="button"
                        >
                            Cancel
                        </FormButton>
                    </div>
                    )}
                </div>
            );
    }

    renderButtons() {
        if (this.props.isEditsAllowed && this.props.hasRejectionPermission) {
            return [
                <Button
                    primary
                    medium
                    bold
                    bigtext
                    notransform
                    onClick={() => this.setState({isRating: true})}
                >
                    Approve
                </Button>,
                <Button
                    danger
                    medium
                    bold
                    bigtext
                    notransform
                    onClick={this.onReject}
                >
                    Deny
                </Button>,
                <Button
                    medium
                    bold
                    bigtext
                    notransform
                    onClick={this.props.gotoApprovalView}
                >
                    Leave Feedback
                </Button>
            ];
        }

        if (this.props.hasRejectionPermission) {
            return [
                <Button
                    primary
                    medium
                    bold
                    bigtext
                    notransform
                    onClick={() => this.setState({isRating: true})}
                >
                    Approve
                </Button>,
                <Button
                    danger
                    medium
                    bold
                    bigtext
                    notransform
                    onClick={this.onReject}
                >
                    Deny
                </Button>,
            ];
        }

        return [
            !this.props.editRequest && (
                <Button
                    medium
                    bold
                    bigtext
                    notransform
                    key="do-not-distribute"
                    className="no-missed-guidelines-approve-or-do-not-post__button"
                    onClick={this.onDoNotPost}
                >
                    Do Not Post
                </Button>
            ),
            !!this.props.isEditsAllowed && (
                <Button
                    medium
                    bold
                    bigtext
                    notransform
                    key="feedback"
                    onClick={this.props.gotoApprovalView}
                >
                    Leave Feedback
                </Button>
            ),
            !this.props.editRequest && (
                <Button
                    medium
                    bold
                    primary
                    bigtext
                    notransform
                    key="approve"
                    onClick={() => {
                        this.setState({isRating: true});
                    }}
                >
                    Approve To Post
                </Button>
            ),
        ];
    }

    renderBrandContentApprovalTimer = () => {
        const {brandApprovalDueDate} = this.props;
        return (
            <div className="content-row__content-approval-timer">
                <ContentApprovalTimer dueDate={brandApprovalDueDate} />
            </div>
        );
    };

    renderActions() {
        const {isRating, status} = this.state;
        const {postState} = this.props;

        if (!this.props.hasRejectionPermission && status === statuses.APPROVED) {
            return (
                <div className="layout-stack content-row__right">
                    <ApprovedBubbles />

                    <div className="content-row__right__heading">
                        Hooray! The creator has been notified to post.
                    </div>
                </div>
            );
        }

        if (
            !this.props.hasRejectionPermission &&
            (postState === 'do_not_distribute' || status === statuses.REJECTED)
        ) {
            return (
                <div className="layout-stack content-row__right">
                    <RejectedBubbles />

                    <div className="content-row__right__heading">
                        Bummer, this content will not be posted.
                    </div>
                </div>
            );
        }

        switch (status) {
            case statuses.APPROVED:
                return (
                    <div className="layout-stack content-row__right">
                        <ApprovedBubbles />

                        <div className="content-row__right__heading">
                            Hooray! This content has been approved
                        </div>
                    </div>
                );
            case statuses.REJECTED:
                return (
                    <div className="layout-stack content-row__right">
                        <RejectedBubbles />

                        <div className="content-row__right__heading">
                            Bummer, this content has been rejected
                        </div>
                    </div>
                );
        }

        if (isRating) {
            return (
                <div className="layout-stack content-row__right">
                    <ApprovedBubbles />

                    <div className="content-row__right__heading">
                        Hooray! This content has been approved
                    </div>
                    <div className="content-row__right__subheading">Content Rating</div>

                    <Rate items={5} icon={ConfigurableStar} onRating={this.handleRating} />

                    <div className="content-row__righ__buttons">
                        <Button
                            medium
                            bigtext
                            notransform
                            bold
                            ghost
                            back
                            key="prev"
                            onClick={() => this.setState({isRating: false})}
                        >
                            Prev
                        </Button>

                        <Button
                            medium
                            bigtext
                            notransform
                            bold
                            key="submit"
                            onClick={this.handleApprove}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            );
        }

        if (this.props.showComments) {
            return [
                <div className="layout-stack content-row__activity">
                    {this.renderBrandContentApprovalTimer()}
                    <div className="content-row__activity-heading">Activity</div>
                    {this.renderComments()}
                </div>,
                <div className="content-row__buttons">{this.renderButtons()}</div>
            ];
        }

       

        return [
            <div className="layout-stack" key={'layout-stack'}>
                {this.renderBrandContentApprovalTimer()}
            </div>,
            <div className="content-row__start-posting-container" key={'posting-container'}>
                <div className="content-row__container-arrow">
                    <span></span>
                </div>
                <p>
                    Select &quot;Approve to Post&quot; and the creator will be notified that they
                    are approved to post their content on their channel.
                </p>

                <ul className="content-row__start-posting-list">
                    <li>
                        <p>
                            If you select &quot;Do Not Post&quot;, please note that the content will
                            still count towards your campaign total but will not be posted to the
                            creator&apos;s channel.
                        </p>
                    </li>

                    <li>
                        <p>
                            If edit requests are enabled on your account and you want the creator to
                            revise the content, click on &quot;Leave Feedback&quot; to provide the
                            necessary edit details.
                        </p>
                    </li>

                    <li>
                        <p>
                            If you do not feel that the content met all the guidelines and should
                            not have been approved, please email your Account Manager before taking
                            any further actions on this piece of content.
                        </p>
                    </li>
                </ul>
            </div>,
            <>
                {!!this.props.isEditsAllowed && (this.state.toggleForm || this.props.editRequest) && (
                    <>
                        {!!this.props.internalMessages.length && (
                            <EditRequestsFormInternal
                                internalMessages={this.props.internalMessages}
                            />
                        )}
                        <EditRequestsForm
                            onCancel={this.handleRequestEditClick}
                            brandEmails={this.props.brandEmails}
                            editRequest={this.props.editRequest}
                            onRequestSubmit={this.props.onRequestSubmit}
                        />
                    </>
                )}
            </>,
            <div className="content-row__buttons">{this.renderButtons()}</div>,
        ];
    }

    render() {
        const {
            platform,
            socialId,
            caption,
            profileImageUrl,
            contentUrl,
            contentType = 'image',
        } = this.props;
        const media =
            contentType === 'image' ? (
                <img src={contentUrl} />
            ) : (
                <video autoPlay={false} controls src={contentUrl} alt="creator content" />
            );

        return (
            <div className="content-row">
                <div className="content-row__content">{media}</div>
                <div className="content-row__main">
                    <div className="content-row__info">
                        <SocialUsernameWithAvatar
                            platform={platform}
                            socialId={socialId}
                            profileImageUrl={profileImageUrl}
                        />

                        <div className="content-row__details">
                            <div className="content-row__details-item">
                                <ContentType
                                    value={this.props.contentSnType}
                                    id={this.props.contentSnTypeId}
                                />
                            </div>

                            {!!this.props.contentCreatedAt && (
                                <div className="content-row__details-item">
                                    <ContentSubmittedDate date={this.props.contentCreatedAt} />
                                </div>
                            )}
                        </div>

                        <Caption>{caption}</Caption>
                    </div>
                    <div className="layout-stack content-row__actions">
                        {this.renderActions()}

                        {this.renderLabels()}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(R.pick(['hasRejectionPermission']))(ContentRow);



// WEBPACK FOOTER //
// ./components/content_row/index.js